export default __webpack_public_path__ + "static/media/object--junction-box.75aae919.png";